import {
  EBuyerBillingStatus,
  EBuyerInvoiceStatus,
  EBuyerPaymentStatus,
} from '@/enums/buyer';

const getBuyerInvoiceStatusName = (status: EBuyerInvoiceStatus): string => {
  switch (status) {
    case EBuyerInvoiceStatus.PENDING:
      return 'รอดำเนินการ';
    case EBuyerInvoiceStatus.ACPT:
      return 'ยอบรับ';
    case EBuyerInvoiceStatus.REJECT:
      return 'ปฏิเสธ';
    default:
      return 'รอดำเนินการ';
  }
};

const getBuyerInvoiceStatusColor = (status: EBuyerInvoiceStatus): string => {
  switch (status) {
    case EBuyerInvoiceStatus.PENDING:
      return 'bg-warning text-dark';
    case EBuyerInvoiceStatus.ACPT:
      return 'bg-success text-white';
    case EBuyerInvoiceStatus.REJECT:
      return 'bg-danger text-white';
    default:
      return 'bg-warning text-dark';
  }
};

const getBuyerInvoiceStatusOptions = () =>
  Object.entries(EBuyerInvoiceStatus).map(([key, value]) => ({
    label: getBuyerInvoiceStatusName(value as EBuyerInvoiceStatus),
    value: value as EBuyerInvoiceStatus,
  }));

const getBuyerBillingStatusName = (status: EBuyerBillingStatus): string => {
  switch (status) {
    case EBuyerBillingStatus.PENDING:
      return 'รอดำเนินการ';
    case EBuyerBillingStatus.ACPT:
      return 'ยอบรับ';
    case EBuyerBillingStatus.REJECT:
      return 'ปฏิเสธ';
    default:
      return 'รอดำเนินการ';
  }
};

const getBuyerBillingStatusColor = (status: EBuyerBillingStatus): string => {
  switch (status) {
    case EBuyerBillingStatus.PENDING:
      return 'bg-warning text-dark';
    case EBuyerBillingStatus.ACPT:
      return 'bg-success text-white';
    case EBuyerBillingStatus.REJECT:
      return 'bg-danger text-white';
    default:
      return 'bg-warning text-dark';
  }
};

const getBuyerBillingStatusOptions = () =>
  Object.entries(EBuyerBillingStatus).map(([key, value]) => ({
    label: getBuyerBillingStatusName(value as EBuyerBillingStatus),
    value: value as EBuyerBillingStatus,
  }));

const getBuyerPaymentStatusName = (status: EBuyerPaymentStatus): string => {
  switch (status) {
    case EBuyerPaymentStatus.PREPARE:
      return 'ยังไม่ได้ส่ง';
    case EBuyerPaymentStatus.PDNG:
      return 'ส่งแล้ว/รอดำเนินการ';
    case EBuyerPaymentStatus.PACC:
      return 'ผู้ซื้อชำระเงินสำเร็จ';
    case EBuyerPaymentStatus.ACCC:
      return ' ผู้ขายได้รับยอดชำระแล้ว';
    case EBuyerPaymentStatus.ERR:
      return 'ชำระเงินไม่สำเร็จ';
    case EBuyerPaymentStatus.CXLD:
      return 'การชำระเงินถูกยกเลิก';
    default:
      return 'ยังไม่ได้ส่ง';
  }
};

const getBuyerPaymentStatusColor = (status: EBuyerPaymentStatus): string => {
  switch (status) {
    case EBuyerPaymentStatus.PDNG:
      return 'bg-primary text-dark';
    case EBuyerPaymentStatus.PACC:
    case EBuyerPaymentStatus.ACCC:
      return 'bg-success text-white';
    case EBuyerPaymentStatus.ERR:
    case EBuyerPaymentStatus.CXLD:
      return 'bg-danger text-white';
    default:
      return 'bg-warning text-dark';
  }
};

const getBuyerPaymentStatusOptions = () =>
  Object.entries(EBuyerPaymentStatus).map(([key, value]) => ({
    label: getBuyerPaymentStatusName(value as EBuyerPaymentStatus),
    value: value as EBuyerPaymentStatus,
  }));

export {
  getBuyerInvoiceStatusOptions,
  getBuyerInvoiceStatusColor,
  getBuyerInvoiceStatusName,
  getBuyerBillingStatusName,
  getBuyerBillingStatusColor,
  getBuyerBillingStatusOptions,
  getBuyerPaymentStatusName,
  getBuyerPaymentStatusColor,
  getBuyerPaymentStatusOptions,
};
